var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioTopSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8927 53.6406L40.0804 53.6406C41.6211 53.6406 42.8691 52.3036 42.8705 50.6528L42.8705 23.9968L44.4307 25.67C44.9536 26.2302 45.6633 26.5455 46.4023 26.544L46.4037 26.544C47.1427 26.544 47.8524 26.2287 48.3753 25.6685L55.1574 18.3931C56.245 17.2249 56.245 15.3351 55.1574 14.1683L42.7561 0.875475C42.2318 0.315256 41.5221 3.6332e-05 40.7831 3.63643e-05L40.7817 3.63643e-05C40.6646 3.63695e-05 40.5489 0.00900091 40.4345 0.0239393C40.3188 0.00750938 40.2017 3.63897e-05 40.0832 3.63949e-05L36.635 3.65456e-05C35.6882 3.6587e-05 34.807 0.513945 34.2939 1.36399C33.1965 3.18059 30.7202 4.35331 27.9872 4.35331C25.2543 4.35331 22.7794 3.18059 21.682 1.36399C21.1689 0.513946 20.2863 3.72602e-05 19.3409 3.73016e-05L15.8927 3.74523e-05C15.7742 3.74575e-05 15.6571 0.009002 15.5413 0.0239404C14.6992 -0.0895964 13.8249 0.22562 13.2198 0.875472L0.815689 14.1698C-0.271898 15.3381 -0.271898 17.2279 0.815689 18.3946L7.59917 25.6685C8.12204 26.2287 8.83316 26.544 9.57216 26.544C10.3126 26.544 11.0223 26.2302 11.5452 25.6685L13.104 23.9983L13.104 50.6528C13.104 52.3021 14.3534 53.6406 15.8927 53.6406Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.2005,
    y1: 50.3411,
    x2: 22.8333,
    y2: -4.51225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioTopSelected);
export default __webpack_public_path__ + "static/media/radioTop_selected.6e39921a512b24749f617121a6ef924c.svg";
export { ForwardRef as ReactComponent };